import PropTypes from 'prop-types';
export const megaMenuListsPropTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    isListWithTiles: PropTypes.bool,
    links: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      href: PropTypes.string,
      picture: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string
      })
    }))
  })),
  handleNestedStateChange: PropTypes.func
};